import { render, staticRenderFns } from "./ReportVaWithRecord.vue?vue&type=template&id=422ab3e0&scoped=true&"
import script from "./ReportVaWithRecord.vue?vue&type=script&lang=js&"
export * from "./ReportVaWithRecord.vue?vue&type=script&lang=js&"
import style0 from "./ReportVaWithRecord.vue?vue&type=style&index=0&id=422ab3e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422ab3e0",
  null
  
)

export default component.exports